import {
  INotifCardSizeEnum,
  INotifCardStyleEnum,
  INotifCardVariantsEnum,
} from "@components/organisms/notify/types";
import { Icon } from "@components/atoms/icon";
import { getThemeColor } from "@/theme";

const getNotifIconColor = (
  variant: INotifCardVariantsEnum,
  style: INotifCardStyleEnum,
) => {
  if (style === INotifCardStyleEnum.Filled) {
    return getThemeColor("static-static-white");
  } else {
    switch (variant) {
      case INotifCardVariantsEnum.Error:
        return getThemeColor("state-error-base");
      case INotifCardVariantsEnum.Warning:
        return getThemeColor("state-warning-base");
      case INotifCardVariantsEnum.Success:
        return getThemeColor("state-success-base");
      case INotifCardVariantsEnum.Information:
        return getThemeColor("state-information-base");
      case INotifCardVariantsEnum.Feature:
        return getThemeColor("state-faded-base");
      case INotifCardVariantsEnum.Promise:
        return getThemeColor("state-information-base");
    }
  }
};

export const getNotifCardIcon = (
  variant: INotifCardVariantsEnum,
  style: INotifCardStyleEnum,
  size: INotifCardSizeEnum,
) => {
  const color = getNotifIconColor(variant, style);

  const icons = {
    [INotifCardVariantsEnum.Error]: (
      <Icon
        name={"ErrorWarningFill"}
        color={color.name}
        fontSize={size === INotifCardSizeEnum.X_Small ? "fs-16" : "fs-20"}
      />
    ),
    [INotifCardVariantsEnum.Warning]: (
      <Icon
        name={"AlertFill"}
        color={color.name}
        fontSize={size === INotifCardSizeEnum.X_Small ? "fs-16" : "fs-20"}
      />
    ),
    [INotifCardVariantsEnum.Success]: (
      <Icon
        name={"CheckboxCircleFill"}
        color={color.name}
        fontSize={size === INotifCardSizeEnum.X_Small ? "fs-16" : "fs-20"}
      />
    ),
    [INotifCardVariantsEnum.Information]: (
      <Icon
        name={"InformationFill"}
        color={color.name}
        fontSize={size === INotifCardSizeEnum.X_Small ? "fs-16" : "fs-20"}
      />
    ),
    [INotifCardVariantsEnum.Feature]: (
      <Icon
        name={"MagicFill"}
        color={color.name}
        fontSize={size === INotifCardSizeEnum.X_Small ? "fs-16" : "fs-20"}
      />
    ),
    [INotifCardVariantsEnum.Promise]: (
      <l-line-spinner size={"20"} stroke={"1.7"} color={color.colorValue} />
    ),
  };

  return icons[variant];
};

export const getNotifCloseIcon = (style: INotifCardStyleEnum) => {
  if (style === INotifCardStyleEnum.Filled)
    return (
      <Icon
        name={"CloseLine"}
        color={"static-static-white"}
        fontSize={"fs-20"}
      />
    );
  return (
    <Icon name={"CloseLine"} color={"icon-strong-950"} fontSize={"fs-20"} />
  );
};

export const getNotifTextColors = (style: INotifCardStyleEnum) => {
  if (style === INotifCardStyleEnum.Filled)
    return getThemeColor("static-static-white");
  return getThemeColor("text-strong-900");
};
